import SessionEvent from 'session/SessionEvent.js';
import Tone from 'tone';
import {TRACK_VOLUME_CHANGE} from 'session/constants.js';

class TrackVolumeChangeEvent extends SessionEvent {
    constructor(track, volume) {
        super();
        this.track = track;
        this.volume = volume;
    }

    getCopy() {
        return new TrackVolumeChangeEvent()
            .fromJson(this.getJson());
    }

    getValue() {
        return this.volume;
    }

    executeEvent(sequencerEngine) {
        if (this.subSequence.tracks[this.track.trackNumber]) {
            this.subSequence.tracks[this.track.trackNumber].setVolume(this.volume, true);
        }
    }

    getType() {
        return TRACK_VOLUME_CHANGE;
    }

    getJson() {
        return {
            ... super.getJson(),
            trackNumber: this.track.trackNumber,
            volume: this.volume
        };
    }

    fromJson(json, sequencerEngine) {
        super.fromJson(json);
        if (json.subSequence !== undefined) {
            this.track = sequencerEngine.getSubSequence(json.subSequence).tracks[json.trackNumber];
        } else {
            this.track  = sequencerEngine.tracks[json.trackNumber];
        }
        this.volume = json.volume;
        return this;
    }
}

export default TrackVolumeChangeEvent;
